<template>
  <div class="recommendcode">
    <div class="container">
      <!-- Content here -->
      <br />

      <nav class="navbar navbar-light bg-light">
        <span class="navbar-brand mb-0 h1">推薦邀請連結</span>
      </nav>

      <br />
      <div class="card">
        <div class="card-body">
          <div>邀請連結: {{ recommendUrl }}</div>
          <br />
          <button
            class="btn btn-info btn-lg btn-block"
            v-clipboard:copy="recommendUrl"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            複製邀請連結
          </button>
        </div>
      </div>
      <br />

      <nav class="navbar navbar-light bg-light">
        <span class="navbar-brand mb-0 h1">使用您的推薦碼下單成功如下:</span>
      </nav>

      <div v-if="displayViews != ''">
        <!-- conent -->
        <div
          v-for="(displayView, index) in recommendOrders"
          v-bind:key="(displayView, index)"
        >
          <div>
            <div class="list-group">
              <li
                class="mt-3 mb-3 list-group-item list-group-item-action flex-column align-items-start"
              >
                <div class="d-flex w-100 justify-content-between">
                  <small></small>
                </div>
                <!-- <input type="checkbox" class="checkbox_size" :value="displayView.key" v-model="checkboxedProds" /> -->
                <p class="mb-1">訂單編號:{{ displayView.key }}</p>
                <p class="mb-1">
                  <b>下單日期: {{ displayView.creat_date.split(' ')[0] }}</b>
                </p>

                <div v-if="displayView.status == 0">
                  <b>
                    <h3>
                      <b-badge variant="primary">等待確認委託單</b-badge>
                    </h3>
                  </b>
                </div>
                <div v-if="displayView.status == 1">
                  <b>
                    <h3>
                      <b-badge variant="warning">確認委託單，等待付款</b-badge>
                    </h3>
                  </b>
                </div>
                <div v-if="displayView.status == 2">
                  <h3>
                    <b-badge variant="info">已付款</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 10">
                  <h3>
                    <b-badge variant="info">阿里巴巴出貨</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 11">
                  <h3>
                    <b-badge variant="info">到中國集運</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 12">
                  <h3>
                    <b-badge variant="success">準備到台灣</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 13">
                  <h3>
                    <b-badge variant="success">出貨完成</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 40">
                  <h3>
                    <b-badge variant="dark">訂單取消</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.total == 0">
                  <p class="mb-1">
                    <b>付款金額: 等待工廠確認</b>
                  </p>
                </div>
                <div v-if="displayView.total != 0 && displayView.status > 0">
                  <p class="mb-1">
                    <b>付款金額: ${{ displayView.total }} 台幣</b>
                  </p>
                </div>
                <small></small>
              </li>
            </div>
          </div>
        </div>
        <!-- conent -->
        <!-- footer -->
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">總共:{{ orderCount }}訂單</p>
          </div>
        </div>
        <!-- footer -->
      </div>
      <div v-else>
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">目前沒有推薦成功任何訂單</p>
          </div>
        </div>
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<style type="text/css"></style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'

export default {
  name: 'recommendcode',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      isLoading: false,
      userId: '',
      recommendUrl: '',
      displayViews: '',
      orderCount: 0,
      recommendOrders: [],
    }
  },
  watch: {},
  methods: {
    CreateRecommendCode: function (userId) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
        }
        await axios
          .post(vm.apiUrl + 'RecommendCode', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            vm.recommendUrl = data.recommend_url
            vm.$toast.open({
              message: '邀請碼產生成功!',
              type: 'success',
            })
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '邀請碼產生失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    QueryRecommendCode: function (userId) {
      const vm = this

      ;(async function post() {
        let formData = {
          recommendCode: 'share|' + userId,
        }
        await axios
          .post(vm.apiUrl + 'QueryOrderByRecommendCode', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            vm.recommendOrders = data
            vm.displayViews = data
            vm.orderCount = vm.recommendOrders.length
            vm.$toast.open({
              message: '查詢成功!',
              type: 'success',
            })
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '查詢失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId ||
          vm.$route.query.userImage ||
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (localStorage.userId == undefined) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
        // vm.$router.push("alibabaorder");
        return true
      } else {
        return false
      }
    },
    onCopy: function () {
      const vm = this
      vm.$toast.open({
        message: '已幫您複製繳邀請連結!',
        type: 'success',
      })
    },
    onError: function () {
      const vm = this
      vm.$toast.open({
        message: '複製失敗!',
        type: 'success',
      })
    },
  },
  mounted() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    const vm = this
    vm.checkUnChatbotSignin()

    vm.userId = decodeURI(vm.$route.query.userId)

    vm.CreateRecommendCode(vm.userId)
    vm.QueryRecommendCode(vm.userId)
  },
}
</script>
